import React from "react"
import MenuIcon from "@mui/icons-material/Menu"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import { Stack } from "@mui/material"
import { drawerWidth } from "@/shared/components/appbar/NavDrawer"

interface Props {
  onToggleDrawer: () => void
}

const MobileTopBar: React.FC<Props> = ({ onToggleDrawer }) => (
  <AppBar
    sx={theme => ({
      backdropFilter: "blur(8px)",
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.mode === "dark" ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.6)",
      backgroundImage: "none",
      color: theme.palette.text.primary,
      boxShadow: "none",
      width: { lg: `calc(100% - ${drawerWidth}px)` },
      ml: { lg: `${drawerWidth}px` }
    })}
    position="fixed">
    <Toolbar sx={{ display: { xs: "flex", md: "none" }, justifyContent: "space-between" }}>
      <Stack width="100%" direction="row" alignItems="center">
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onToggleDrawer}
          sx={{ display: { md: "none" } }}>
          <MenuIcon color="action" />
        </IconButton>
      </Stack>
    </Toolbar>
  </AppBar>
)

export default MobileTopBar
